import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LoadingBox from 'components/Common/Loading/LoadingBox'

const ChatPreviewSkeleton = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr minmax(0, 1fr);
  grid-column-gap: ${rem(12)};
  grid-row-gap: ${rem(4)};
  width: 100%;
  height: ${rem(60)};
  padding: ${rem(12)} ${rem(24)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
`

const AvatarSkeleton = styled(LoadingBox)`
  grid-column: 1;
  grid-row: 1 / span 2;
  width: ${rem(24)};
  height: ${rem(24)};
  align-self: start;
  border-radius: ${props => props.theme.borderRadius.round};
`

const ChatTitleSkeleton = styled(LoadingBox)`
  grid-column: 2;
  grid-row: 1;
  border-radius: ${props => props.theme.borderRadius.XS};
`

const ChatMetaSkeleton = styled(LoadingBox)`
  grid-column: 2;
  grid-row: 2;
  border-radius: ${props => props.theme.borderRadius.XS};
`

function ChatPreviewLoadingSkeleton() {
  return <ChatPreviewSkeleton>
    <AvatarSkeleton />
    <ChatTitleSkeleton />
    <ChatMetaSkeleton />
  </ChatPreviewSkeleton>
}

export default ChatPreviewLoadingSkeleton
